import type React from 'react';
import type { IconProps } from 'types/icon';

const Scale: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M13.4832 11.0956L12.8486 13.2866L13.8739 13.5988L14.5085 11.4078L13.4832 11.0956Z"
        fill={color}
      />
      <path
        d="M12.0721 14.0331C13.8014 14.0331 15.4408 14.807 16.5653 16.1548L16.9102 16.5699L22.0681 12.0499L21.7232 11.6348C19.3092 8.73927 15.7906 7.07886 12.0721 7.07886C8.35363 7.07886 4.84005 8.73927 2.42103 11.6399L2.07617 12.055L7.23408 16.575L7.57894 16.1599C8.70349 14.8121 10.3428 14.0383 12.0721 14.0383V14.0331ZM7.12413 15.0376L3.58556 11.9371L3.87044 11.645C6.06455 9.40549 8.97338 8.17043 12.0721 8.17043C15.1709 8.17043 18.0797 9.40549 20.2738 11.645L20.5587 11.9371L17.0201 15.0376L16.7752 14.807C15.4907 13.6027 13.8164 12.9364 12.0721 12.9364C10.3278 12.9364 8.6535 13.6027 7.36903 14.807L7.12413 15.0325V15.0376Z"
        fill={color}
      />
    </svg>
  );
};

export default Scale;
